import { render, staticRenderFns } from "./NavigateToJourneyButton.vue?vue&type=template&id=36f79fe2&"
import script from "./NavigateToJourneyButton.vue?vue&type=script&lang=js&"
export * from "./NavigateToJourneyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f79fe2')) {
      api.createRecord('36f79fe2', component.options)
    } else {
      api.reload('36f79fe2', component.options)
    }
    module.hot.accept("./NavigateToJourneyButton.vue?vue&type=template&id=36f79fe2&", function () {
      api.rerender('36f79fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Elements/NavigateToJourneyButton.vue"
export default component.exports